import { definePlugin } from '@seedkit/core';
import VueApexCharts from 'vue3-apexcharts';

//eslint-disable-next-line
//@ts-ignore
export default definePlugin((seedkit) => {
  // seedkit.services.register('apexcharts', VueApexCharts);
  seedkit.app.use(VueApexCharts);

  return {
    name: 'apexcharts',
    version: '1.0.0',
    description: 'Apexcharts plugin',
    async boot() {
      //
    },
  };
});
